import axios from "axios";
import authHeader from "./auth-header";
import IChangePassword from "../types/authentication/change-password-request.type";
import IUpdatePassword from "../types/update-password.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/auth/`;

export const login = (username: string, password: string) => {
  return axios
    .post(API_URL + "login", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

export const forgotPassword = (username: string) => {
  return axios.post(API_URL + "reset-password?username=" + username);
}

export const resetPassword = (password: IChangePassword) => {
  return axios.post(API_URL + "change-password", password, { headers: authHeader() });
}

export const updatePassword = (password: IUpdatePassword) => {
  return axios.post(API_URL + "update-password", password, { headers: authHeader() });
}

export const logout = () => {
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);

  return null;
};
